import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SiteService } from '../../../core/site';
import { SelectedSiteService } from '../../../selected-site.service';
import { BaseHomeComponent } from '../base.home.component';
import { SiteEditService } from '../../../core/site-edit';
import { LocalStorageService } from '@vendasta/uikit';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-template-home',
  templateUrl: './template.home.component.html',
  styleUrls: ['./template.home.styles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TemplateHomeComponent extends BaseHomeComponent implements OnDestroy {
  constructor(
    protected siteService: SiteService,
    protected selectedSiteService: SelectedSiteService,
    protected diviUrlsService: SiteEditService,
    protected localStorageService: LocalStorageService,
    public analyticsService: ProductAnalyticsService,
  ) {
    super(siteService, selectedSiteService, diviUrlsService, localStorageService, null, null, analyticsService);
  }
}
